<script setup>
import {computed} from "vue";

const props = defineProps({
  priority: {
    type: Number,
    required: true,
  }
});

const label = computed(() => {
  if (props.priority < 5) {
    return 'Low';
  }
  if (props.priority < 8) {
    return 'Medium';
  }

  return 'High';
});

const colorsClass = computed(() => {
  if (label.value === 'Low') {
    return 'tw-text-[#006666] tw-bg-[#D4FAED] tw-border-[#0ACCCC]';
  }

  if (label.value === 'Medium') {
    return 'tw-text-[#660099] tw-bg-[#EEE5FF] tw-border-[#9161F2]';
  }

  return 'tw-text-[#7C3603] tw-bg-[#FFEEE5] tw-border-[#FF884D]';
})
</script>

<template>
  <div :class="['tw-py-2 tw-px-4 tw-rounded-full tw-text-sm tw-font-semibold tw-border', colorsClass]">
    {{ label }}
  </div>
</template>
